// EmailJS 配置
// 请替换为您的实际配置信息

export const EMAILJS_CONFIG = {
  // EmailJS 服务 ID
  SERVICE_ID: 'service_dczjbzo',
  
  // EmailJS 模板 ID
  TEMPLATE_ID: 'template_cqk7o3d',
  
  // EmailJS 公钥
  PUBLIC_KEY: 'JtRvo-MAM7WZ-rHHB'
}
